import i18n from 'i18next';
import values from 'lodash/values';
import omit from 'lodash/fp/omit';
import { compose } from 'ramda';
import { reduce } from 'lodash/fp';
import { isIntegratedPreArrivalChargeEnabled } from 'components/helpers';
import { useAppState } from 'AppProvider';

const usePMSGuestOptions = <T>(types: T) => {
  const { integrations } = useAppState(
    (state: Record<string, unknown>) => state.brand,
  );
  const isEnabled = isIntegratedPreArrivalChargeEnabled(integrations);

  return compose(
    values,
    omit(!isEnabled ? ['preArrivalGuest'] : []),
    reduce((acc, value) => {
      Object.assign(acc, {
        [value]: {
          name: value,
          label: i18n.t(value),
        },
      });
      return acc;
    }, {}),
    values,
  )(types);
};

export default usePMSGuestOptions;
